import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import IconControl from './icon-control'
import { SidebarOffset } from '../lib/constants'
import linkify from '../lib/linkify'
import isMobile from '../lib/is-mobile'

const StyledLink = linkify(styled.div`
  margin-top: 6px;
  margin-bottom: 12px;
`)

const InlineStyledLink = linkify(styled.span``)

interface IProps {
  index: number
  inline: boolean
}

const scrollToElement = (id: number) => {
  const element = document.getElementById(`scene-${id}`)
  if (!element) return

  if (isMobile()) {
    window.scrollTo(0, element.offsetTop - SidebarOffset)
    return
  }

  document
    .getElementById('content-scroll-container')
    ?.scrollTo(0, element.offsetTop - SidebarOffset)
}

const LinkToSceneControl = (props: PropsWithChildren<IProps>) => {
  if (props.inline) {
    return (
      <InlineStyledLink
        onClick={scrollToElement.bind(null, props.index)}
        className="link-to-scene"
      >
        {props.children}
      </InlineStyledLink>
    )
  } else {
    return (
      <StyledLink
        onClick={scrollToElement.bind(null, props.index)}
        className="link-to-scene"
      >
        <IconControl icon="arrow-down" />
        {props.children}
      </StyledLink>
    )
  }
}

export default LinkToSceneControl
